import React, { Component } from 'react'
import Axios from 'axios';
import LS_SERVICE from '../../utils/localStorage';
import { Link } from 'react-router-dom'
import Asideleft from '../../components/aside/asideleft'
import { Form, Select } from 'antd';
import {
  LOADER_RED,
  SHARED_INTERNAL_NOTES,
  STORE_SHARED_INTERNAL_NOTES,
  IPD_APP_HOST
} from '../../utils/constant';
import { headerService$, speechService, speechTextService } from '../../utils/rxjs-sharing';
import moment from 'moment';
import { SPECIALITY_LIST } from '../../utils/constant';
import qs from 'qs';

const { Option } = Select;

export default class PACFormBuilder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      saveBtnDisable: true,
      patient: null,
      hospital_id: null,
      patient_id: null,
      reference_id: null,
      allowEdit: true,
      shared_internal_notes: '',
      FormBuilderInfo: [],
      speech: {
        identifier: null,
        state: false
      },
      specialityList: [],
      speciality_list_id: [],
      patientUhid: LS_SERVICE.get('call_patient_detail').uhid
    }
    this.specialityFormRef = React.createRef();
  }
  autoHeight = (e) => {
    e.target.style.height = e.target.scrollHeight + "px";
  }

  async componentWillUnmount() {
    this.subscription.unsubscribe();
  }

  async componentDidMount() {
    Axios.defaults.headers.common["Authorization"] = LS_SERVICE.get("token");
    const { match: { params } } = this.props;
    const { hospital_id, patient_id, reference_id } = params;

    const patient = {
      hospital_id,
      patient_id,
      qms_token_id: reference_id
    }

    let hospitalConfigData = LS_SERVICE.get('hospitalConfigData') ?? [];
    hospitalConfigData = hospitalConfigData.find(item => item.hospital_id == hospital_id);
    this.subscription = speechTextService.status().subscribe(async data => {
      if (this.state.speech.state) {
        if (this.state.speech.identifier === 'shared_internal_notes') {
          this.setState({ shared_internal_notes: data.text, detect_change: true }, () => { /* this.handleConfirmBtnStatus() */ });
          document.querySelector("#" + this.state.speech.identifier).style.height = document.querySelector("#" + this.state.speech.identifier).scrollHeight + "px";
        }
      }
    });
    this.handleSerachSpecList('');
    this.setState({
      hospital_id,
      patient_id,
      reference_id,
      patient,
    }, () => {
      if (LS_SERVICE.has('hospitalConfigData')) {
        const hospitalConfigData = LS_SERVICE.get('hospitalConfigData');
        let hospitalConfigObj = hospitalConfigData.find(obj => obj.hospital_id == hospital_id);
        headerService$.soapConfig({ soapConfig: hospitalConfigObj?.opd_layout || 'single' }); // IMPORTANT TO HIT AS PER THE VIEW
        this.getFormBuilder();
      }
    });

  }

  handleSerachSpecList = search => {
    const PARAMS = { search }
    Axios.post(SPECIALITY_LIST, qs.stringify(PARAMS))
      .then(res => {
        this.setState({
          specialityList: res.data.status ? res.data.data.results : [],
        })
      })
  }


  async getFormBuilder() {
    const { reference_id } = this.state;
    const { patient } = this.state;
    const { patient_id } = patient;
    const notes = await Axios.get(SHARED_INTERNAL_NOTES({ reference_type: LS_SERVICE.get('reference_type'), reference_id: reference_id, type: 'soap', patient_id: patient_id }));
        if (typeof notes.data != 'undefined' && typeof notes.data.data != 'undefined') {
      await this.setState({
        FormBuilderInfo: notes.data.data
      });
    }
  }

  handleOnChange = event => {
    const { name, value } = event.currentTarget;
    var identifierValue = event.target.id;

    let regex_aplhabet = /[a-zA-Z]/
    const isValidAlphabet = regex_aplhabet.test(value);

    let saveBtnDisable = false;

    if(!isValidAlphabet){
      saveBtnDisable = true;
    }
    this.setState((prevState) => ({
      [name]: value,
      saveBtnDisable: saveBtnDisable,
      speech: {
        ...prevState.speech,
        identifier: identifierValue,
        initialText: value
      }
    }), () => { /* this.handleConfirmBtnStatus(); */ })
  }

  initSpeech(info) {
    let initialText = '';
    if (info.identifier === 'shared_internal_notes') {
      initialText = this.state.shared_internal_notes != undefined ? this.state.shared_internal_notes : '';
    }

    if (info.identifier === this.state.speech.identifier) {
      this.setState({
        speech: {
          identifier: info.identifier,
          state: !this.state.speech.state,
          initialText: initialText
        },
        saveBtnDisable: false,
      }, () => {
        speechService.init(this.state.speech);
      });
    } else {
      // console.log("IN Different MIC Previous Unclosed")
      this.setState({
        speech: {
          identifier: this.state.speech.identifier,
          state: false,
          initialText: ''
        },
        saveBtnDisable: false,
      }, () => {
        speechService.init(this.state.speech);

        if (!this.state.speech.state) {
          this.handleRestartMic(info, initialText)
        }
        // console.log("State in init:",this.state.speech)

      });

    }
  }

  handleRestartMic = (info, initialText) => {
    // debugger
    this.setState({
      speech: {
        identifier: info.identifier,
        state: true,
        initialText: initialText
      },
      saveBtnDisable: false
    }, () => {
      // console.log("State in init:",this.state.speech)
      speechService.init(this.state.speech);
    });
  }

  handleOnFocus = (e) => {
    var identifierValue = this.state.speech.identifier === e.target.id ? e.target.id : this.state.speech.identifier;
    this.setState(prevState => ({
      speech: {
        ...prevState.speech,
        identifier: identifierValue,
        state: false,
        initialText: identifierValue === "shared_internal_notes" ? this.state.shared_internal_notes : ''
      }
    }), () => {
      speechService.init(this.state.speech)
      // this.initSpeech({identifier: e.target.id})
    })
  }

  handleFormSubmit = async () => {
    const { shared_internal_notes, patient, speciality_list_id } = this.state;
    const { qms_token_id } = patient;
    const { patient_id } = patient;
    const PARAMS = {
      reference_type: LS_SERVICE.get('reference_type'),
      reference_id: qms_token_id,
      shared_internal_notes: shared_internal_notes,
      staff_id: LS_SERVICE.get("staff_id"),
      speciality_list_id: speciality_list_id,
      patient_id: patient_id
    };


    let submitPromise;
    submitPromise = await Axios.post(STORE_SHARED_INTERNAL_NOTES, PARAMS);

    if (submitPromise.data?.status) {
      await this.setState({
        saveBtnDisable: true,
        shared_internal_notes: '',
        speciality_list_id: []
      });
      this.specialityFormRef.current.resetFields();
      this.getFormBuilder();
    }
  }

  fetchDetails = async () => {
    const { shared_internal_notes, patient, speciality_list_id } = this.state;
    const { qms_token_id } = patient;
    const { patient_id } = patient;
    const PARAMS = {
      reference_type: LS_SERVICE.get('reference_type'),
      reference_id: qms_token_id,
      shared_internal_notes: shared_internal_notes,
      staff_id: LS_SERVICE.get("staff_id"),
      speciality_list_id: speciality_list_id,
      patient_id: patient_id
    };


    let submitPromise;
    submitPromise = await Axios.post(STORE_SHARED_INTERNAL_NOTES, PARAMS);

    if (submitPromise.data?.status) {
      await this.setState({
        saveBtnDisable: true,
        shared_internal_notes: '',
        speciality_list_id: []
      });
      this.specialityFormRef.current.resetFields();
      this.getFormBuilder();
    }
  }

  handleSpecialListChange = async (speciality_list_id) => {
    await this.setState({ speciality_list_id: speciality_list_id })
  }

  render() {
    const { patient, FormBuilderInfo, specialityList, patientUhid, reference_id } = this.state;
    var encounter_id = LS_SERVICE.get('PATIENT_ENCOUNTER_ID');
    var mhea_patient_id = LS_SERVICE.get('PATIENT_REG_DATA')?.registrationid;
    var speciality_id = LS_SERVICE.get('speciality_id');
    var enterprise_id = LS_SERVICE.get('ENTERPRISE_ID');
    var enterprise_name = LS_SERVICE.get('ENTERPRISE_NAME');
    var facility_id = LS_SERVICE.get('FACILITY_ID');
    var doctor_id = LS_SERVICE.get('staff_id');
    var his_token = LS_SERVICE.get('HIS_TOKEN');
    var token = LS_SERVICE.get('auth_token');
    var mhea_role_id = LS_SERVICE.get('mhea_role_id');
    return (
      <>
        <Asideleft />

        <div className="content-wrapper">
          <div className="container-fluid emrfrm ">
            <iframe name="iframe1" height="700" style={{width: "100%"}} src={IPD_APP_HOST+`OPDPACForm?source=opd&uhid=${patientUhid}&encounter_id=${encounter_id}&patient_id=${mhea_patient_id}&speciality_id=${speciality_id}&enterprise_id=${enterprise_id}&enterprise_name=${enterprise_name}&facility_id=${facility_id}&doctor_id=${doctor_id}&role_id=${mhea_role_id}&his_token=${his_token}&token=${token}`}></iframe>
          </div>
        </div>
      </>
    )
  }
}